import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window !== "undefined") {
      return localStorage.getItem("vpsm_lang") || "mr";
    }
    return "mr";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("vpsm_lang", lang);
      document.documentElement.lang = lang === "mr" ? "mr" : "en";
    }
  }, [lang]);

  const t = translations[lang];
  const toggleLang = () => setLang((p) => (p === "mr" ? "en" : "mr"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
